<template>
  <figure v-show="ratio > 0">
    <img ref="image" :src="src" :alt="alt" :style="dimensions" />
  </figure>
</template>

<script>
export default {
  name: 'BoundImage',

  props: {
    src: { type: String, required: true },
    alt: { type: String, default: '' },
    maxHeight: { type: Number, default: 100 },
    maxWidth: { type: Number, default: 100 },
  },

  data() {
    return {
      originalHeight: 0,
      originalWidth: 0,
    }
  },

  computed: {
    ratio() {
      return this.originalHeight === 0 ? 0 : this.originalWidth / this.originalHeight
    },

    dimensions() {
      const { height, width } = this.shrinkToWidth(this.expandToHeight())

      return {
        height: `${height}px`,
        width: `${width}px`,
      }
    },
  },

  methods: {
    expandToHeight() {
      const adjustedHeight = this.maxHeight
      const adjustedWidth = this.ratio * adjustedHeight

      const dims = { height: adjustedHeight, width: adjustedWidth }
      return dims
    },

    shrinkToWidth({ height, width }) {
      if (width <= this.maxWidth) {
        return { height, width }
      } else {
        const adjustedWidth = this.maxWidth
        const adjustedHeight = this.ratio > 0 ? adjustedWidth / this.ratio : 0

        const dims = { height: adjustedHeight, width: adjustedWidth }
        return dims
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.image.onload = () => {
        this.originalHeight = this.$refs.image.naturalHeight
        this.originalWidth = this.$refs.image.naturalWidth
      }
    })
  },
}
</script>
